import { render, staticRenderFns } from "./EventsStudy.vue?vue&type=template&id=78269ee2&"
import script from "./EventsStudy.vue?vue&type=script&lang=js&"
export * from "./EventsStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports